
export default{
    // Serveur fournisseur de données - back-end
    hostACF : 'https://gestion.domainethibaut.fr/wp-json/wp/v2/',
    // Routes spécifiques
    host : 'https://gestion.domainethibaut.fr/wp-json/',


    domaineID: 78,
    idEcoMusee: 279,
    offres: {
        privatisation: 208
    },

    emailJSserviceContact: 'f3wb7m2',
    emailJStemplateContact: '762q3an',
    emailJSkeyContact: '2SxL_0w9ClW8gTiaI',

    listeMois: [
        {
            title: 'Janvier',
            text: 'janvier',
            numerique: '01',
            id: 1
        },
        {
            title: 'Février',
            text: 'fevrier',
            numerique: '02',
            id: 2
        },
        {
            title: 'Mars',
            text: 'mars',
            numerique: '03',
            id: 3
        },
        {
            title: 'Avril',
            text: 'avril',
            numerique: '04',
            id: 4
        },
        {
            title: 'Mai',
            text: 'mai',
            numerique: '05',
            id: 5
        },
        {
            title: 'Juin',
            text: 'juin',
            numerique: '06',
            id: 6
        },
        {
            title: 'Juillet',
            text: 'juillet',
            numerique: '07',
            id: 7
        },
        {
            title: 'Août',
            text: 'aout',
            numerique: '08',
            id: 8
        },
        {
            title: 'Septembre',
            text: 'septembre',
            numerique: '09',
            id: 9
        },
        {
            title: 'Octobre',
            text: 'octobre',
            numerique: '10',
            id: 10
        },
        {
            title: 'Novembre',
            text: 'novembre',
            numerique: '11',
            id: 11
        },
        {
            title: 'Décembre',
            text: 'decembre',
            numerique: '12',
            id: 12
        }
    ],

    // Jours
        joursSemaineFR: new Array('Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'),
        joursSemaineEN: new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'),
        joursTypes: new Array('Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche', 'Jour_ferie'),
        joursTypesText: new Array('Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche', 'Jour férié'),


    regexMail: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    regexTel: /^\d{10}$/,

    // Authentification JWT Wordpress
        // auth : 'http://localhost/wordpress/wp-json/jwt-auth/v1/',
        //   user : 'admin',
        //   psw : 'admin',
   
}




// WEBPACK FOOTER //
// ./src/param/param.js